import styled, { css } from 'styled-components';
import { COLOURS, getBodyFont, isFocused, Z_INDEX } from '@belong/themes';
import { Icon } from '@belong/ui-components/components/Icon';

export const ANIMATION_DURATION = 300; // ms

export const StartChat = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  z-index: -1;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  color: ${COLOURS.BLACK};
  background-color: ${COLOURS.WHITE};

  opacity: 0;
  transition: opacity ${ANIMATION_DURATION}ms ease-out;

  @media (prefers-reduced-motion) {
    transition: none;
  }
`;

export const MessageIcon = styled(Icon)`
  position: relative;
  transform: scale(1);
  transition: transform ${ANIMATION_DURATION}ms ease-out;

  @media (prefers-reduced-motion) {
    transition: none;
  }
`;

export const TextPrompt = styled.span`
  display: block;
  position: relative;
  ${getBodyFont('xs', 'small')}
`;

export const TheButton = styled.button<{ isLarge?: boolean }>`
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  bottom: 0;
  background: none;
  font: inherit;
  border: none;
  cursor: pointer;
  opacity: 1;
  padding: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: ${COLOURS.BLACK};
  color: ${COLOURS.WHITE};
  width: 56px;
  height: 56px;

  border-radius: 50%;
  overflow: hidden;

  &:focus {
    ${isFocused()};
    outline-offset: 0.4rem;
  }
`;

export const UnreadCount = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  padding: 0 8px;
  top: -5px;
  left: -5px;
  min-width: 24px;
  height: 24px;

  border-radius: 100px;
  background: ${COLOURS.BRIGHT_GREEN};
  ${getBodyFont('xs', 'medium')}
`;

export const ButtonWrapper = styled.div<{ visible?: boolean }>`
  z-index: ${Z_INDEX.GLOBAL_HEADER - 1};
  position: fixed;
  right: 16px;
  bottom: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(
    250deg,
    #d2f560 17.27%,
    #60f5b1 28.61%,
    #67c5eb 42.93%,
    #cd91ff 63.36%,
    #ff6fff 76.95%,
    #ffc192 89.3%
  );
  box-shadow:
    0px 4px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -2px rgba(0, 0, 0, 0.1);

  ${props =>
    !props.visible &&
    css`
      right: -50px;
      opacity: 0;
      visibility: hidden;
    `}

  transform: scale(1);
  transition: all ${ANIMATION_DURATION}ms ease-out;
  @media (prefers-reduced-motion) {
    transition: none;
  }

  &:hover,
  &:focus {
    background: ${COLOURS.BLACK};
    transform: scale(1.1);
    box-shadow:
      0px 20px 25px -5px rgba(0, 0, 0, 0.2),
      0px 10px 5px -3px rgba(0, 0, 0, 0.04);

    ${StartChat} {
      opacity: 1;
      z-index: 1;
    }

    ${MessageIcon} {
      transform: scale(3);
    }
  }
`;
